import React, { useState, useCallback } from "react";
import { Quote, RefreshCw } from "lucide-react";

const QUOTES = [
  { t: "The way to get started is to quit talking and begin doing.", a: "Walt Disney" },
  { t: "Ideas are easy. Implementation is hard.", a: "Guy Kawasaki" },
  { t: "Your most unhappy customers are your greatest source of learning.", a: "Bill Gates" },
  { t: "Done is better than perfect.", a: "Sheryl Sandberg" },
  { t: "The best time to plant a tree was 20 years ago. The second best time is now.", a: "Proverb" },
  { t: "Make something people want.", a: "Paul Graham" },
  { t: "Success is a lousy teacher. It seduces smart people into thinking they can't lose.", a: "Bill Gates" },
  { t: "If you are not embarrassed by the first version of your product, you've launched too late.", a: "Reid Hoffman" },
  { t: "Start where you are. Use what you have. Do what you can.", a: "Arthur Ashe" },
  { t: "A goal without a plan is just a wish.", a: "Antoine de Saint-Exupéry" },
  { t: "Move fast and fix things.", a: "The Founder's Creed" },
  { t: "Chase the vision, not the money; the money will end up following you.", a: "Tony Hsieh" },
];

export default function QuoteBanner() {
  const [i, setI] = useState(() => Math.floor(Math.random() * QUOTES.length));
  const next = useCallback(() => setI((p) => (p + 1 + Math.floor(Math.random() * (QUOTES.length - 1))) % QUOTES.length), []);
  const q = QUOTES[i];

  return (
    <div data-testid="quote-banner" className="rounded-2xl border border-orange-500/20 bg-gradient-to-r from-orange-500/10 via-rose-500/5 to-teal-500/10 p-5 flex items-start gap-4">
      <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-orange-400 to-rose-500 grid place-items-center shrink-0">
        <Quote className="h-5 w-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p data-testid="quote-text" className="font-display text-base sm:text-lg text-slate-100 leading-snug">"{q.t}"</p>
        <p className="text-sm text-slate-400 mt-1">— {q.a}</p>
      </div>
      <button data-testid="quote-refresh" onClick={next} className="text-slate-400 hover:text-orange-300 transition shrink-0" title="Another quote">
        <RefreshCw className="h-4 w-4" />
      </button>
    </div>
  );
}
